import { isHolidayMenusLive } from '@/lib/experienceLaunch';
import { useEffect, useState } from 'react';

export function useHolidayMenusLive() {
  const [isLive, setIsLive] = useState(() => isHolidayMenusLive());

  useEffect(() => {
    const sync = () => setIsLive(isHolidayMenusLive());
    sync();

    const intervalId = window.setInterval(sync, 60_000);
    return () => window.clearInterval(intervalId);
  }, []);

  return isLive;
}
